import React from "react";

function Bach({ children }) {
  return (
    <p className="uppercase text-sm tracking-wider bg-primary-100 inline-block py-1 px-2 border-primary-900 bg-opacity-30 rounded-2xl border mb-3 text-center">
      {children}
    </p>
  );
}

export default Bach;
